export default {
  generateAcceptedLetters: state => letters => {
    const letterTypes = new Set()
    letters.forEach(letter => {
      letter.quotes.forEach(quote => {
        const { dc_type } = quote
        letterTypes.add(dc_type)
      })
    })
    const emptyDcType = {}

    letterTypes.forEach(v => {
      emptyDcType[v] = 0
    })
    const totalDirections = []

    const list = []
    letters.forEach(letter => {
      const org = letter.from_org
      const directions = []
      const orgEmptyDcType = emptyDcType
      let total = 0
      letter.quotes.forEach(quote => {
        if (!directions[quote.direction.id]) {
          directions[quote.direction.id] = {
            name: quote.direction,
            ...emptyDcType,
            total: 0,
          }
        }
        if (!totalDirections[quote.direction.id]) {
          totalDirections[quote.direction.id] = {
            name: quote.direction,
            ...emptyDcType,
            total: 0,
          }
        }
        directions[quote.direction.id][quote.dc_type] += quote.amount
        totalDirections[quote.direction.id][quote.dc_type] += quote.amount
        directions[quote.direction.id].total += quote.amount
        totalDirections[quote.direction.id].total += quote.amount
        orgEmptyDcType[quote.dc_type] += quote.amount
        total += quote.amount
      })
      list.push({
        name: org,
        ...orgEmptyDcType,
        total,
        directions,
      })
    })

    return {
      list,
      directions: Object.values(totalDirections),
    }
  },
}
